import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import { Modal } from './Modal';
import { toast } from '../stores/toasts';
import type { PayMethod } from '../types';

interface PaymentModalProps {
  open: boolean;
  onClose: () => void;
  orderId: string;
  balance: number;
  onAdded: () => void;
}

const METHODS: { value: PayMethod; label: string; emoji: string }[] = [
  { value: 'CASH', label: 'Naqd', emoji: '💵' },
  { value: 'CARD', label: 'Karta', emoji: '💳' },
  { value: 'TRANSFER', label: "O'tkazma", emoji: '🏦' },
  { value: 'OTHER', label: 'Boshqa', emoji: '📋' },
];

export function PaymentModal({ open, onClose, orderId, balance, onAdded }: PaymentModalProps) {
  const [method, setMethod] = useState<PayMethod>('CASH');
  const [amount, setAmount] = useState(String(balance));
  const [externalId, setExternalId] = useState('');

  const add = useMutation({
    mutationFn: () =>
      api.addPayment(orderId, {
        method,
        amount: Number(amount),
        externalId: externalId || undefined,
      }),
    onSuccess: () => {
      toast.success("To'lov qabul qilindi");
      setExternalId('');
      onAdded();
      onClose();
    },
    onError: (e: any) => toast.error(e?.message || 'Xatolik'),
  });

  function submit() {
    const a = Number(amount);
    if (!a || a <= 0) {
      toast.warning('Summani kiriting');
      return;
    }
    add.mutate();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="💰 To'lov qabul qilish"
      footer={
        <>
          <button className="btn" onClick={onClose}>Bekor</button>
          <button className="btn btn-primary" onClick={submit} disabled={add.isPending}>
            {add.isPending ? 'Saqlanmoqda...' : 'Qabul qilish'}
          </button>
        </>
      }
    >
      <div className="muted" style={{ marginBottom: 12 }}>
        Qarz: <b className="amount">{balance.toLocaleString('uz-UZ')} so'm</b>
      </div>
      <div className="field">
        <label className="field-label">Usuli</label>
        <div className="chips">
          {METHODS.map((m) => (
            <div
              key={m.value}
              className={`chip ${method === m.value ? 'active' : ''}`}
              onClick={() => setMethod(m.value)}
            >
              {m.emoji} {m.label}
            </div>
          ))}
        </div>
      </div>
      <div className="field">
        <label className="field-label">Summa (so'm)</label>
        <input
          type="number"
          min="0"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>
      {method !== 'CASH' && (
        <div className="field">
          <label className="field-label">Tashqi ID (ixtiyoriy)</label>
          <input
            placeholder="Chek raqami yoki tranzaksiya"
            value={externalId}
            onChange={(e) => setExternalId(e.target.value)}
          />
        </div>
      )}
    </Modal>
  );
}
